import { render, staticRenderFns } from "./LabelGeneratorDialog.vue?vue&type=template&id=232f036e&"
import script from "./LabelGeneratorDialog.vue?vue&type=script&lang=ts&"
export * from "./LabelGeneratorDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports